import styled from "@emotion/styled";
import { Button, IconButton } from "@avenue-8/sidekick-ui";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const StyledButton = styled(Button)`
  display: flex;
  align-self: flex-start;
  justify-self: flex-start;
  width: fit-content;
  padding: 0.5rem;
  margin-left: -0.5rem;
  margin-bottom: 1rem;
`;

const StyledIconButton = styled(IconButton)`
  margin-left: -0.5rem;
`;

type Props = {
  onClick: () => void;
  disabled?: boolean;
  /** Icon-only, for placing inline next to a step title instead of on its own row. */
  iconOnly?: boolean;
};

export const SubscriptionBackButton = ({
  onClick,
  disabled,
  iconOnly,
}: Props) =>
  iconOnly ? (
    <StyledIconButton
      aria-label="Back"
      size="small"
      onClick={onClick}
      disabled={disabled}
    >
      <ArrowBackIcon fontSize="small" />
    </StyledIconButton>
  ) : (
    <StyledButton
      variant="text"
      size="small"
      startIcon={<ArrowBackIcon fontSize="small" />}
      onClick={onClick}
      disabled={disabled}
    >
      Back
    </StyledButton>
  );
